var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form__field-holder",
      class: { "form__field-holder_error": !!_vm.errors.has(_vm.newName) },
      attrs: { "data-vv-value-path": "model", "data-vv-as": _vm.label }
    },
    [
      _c("div", { staticClass: "form__field-box" }, [
        _vm.showLabel && _vm.labelHtml
          ? _c("label", {
              staticClass: "form__label",
              domProps: { innerHTML: _vm._s(_vm.labelHtml) }
            })
          : _vm.showLabel
          ? _c("label", { staticClass: "form__label" }, [
              _vm._v("\n      " + _vm._s(_vm.label) + "\n    ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "form__input-item",
              _vm.IsExtraInfo ? "form__extra-info" : ""
            ],
            staticStyle: { position: "relative" }
          },
          [
            (_vm.type || "text") === "checkbox"
              ? _c(
                  "input",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model,
                          expression: "model"
                        }
                      ],
                      staticClass: "form__textfield",
                      attrs: {
                        name: _vm.name,
                        disabled: _vm.disabled,
                        placeholder: _vm.placeholder,
                        min: _vm.min,
                        max: _vm.max,
                        autocomplete: _vm.autocomplete,
                        type: "checkbox"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.model)
                          ? _vm._i(_vm.model, null) > -1
                          : _vm.model
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.model,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.model = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.model = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.model = $$c
                            }
                          },
                          function($event) {
                            return _vm.$emit("change", $event)
                          }
                        ],
                        blur: function($event) {
                          return _vm.$emit("blur", $event)
                        }
                      }
                    },
                    _vm.limitNumbersInput
                      ? {
                          input: function() {
                            return _vm.limitInput(10)
                          }
                        }
                      : {}
                  )
                )
              : (_vm.type || "text") === "radio"
              ? _c(
                  "input",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model,
                          expression: "model"
                        }
                      ],
                      staticClass: "form__textfield",
                      attrs: {
                        name: _vm.name,
                        disabled: _vm.disabled,
                        placeholder: _vm.placeholder,
                        min: _vm.min,
                        max: _vm.max,
                        autocomplete: _vm.autocomplete,
                        type: "radio"
                      },
                      domProps: { checked: _vm._q(_vm.model, null) },
                      on: {
                        change: [
                          function($event) {
                            _vm.model = null
                          },
                          function($event) {
                            return _vm.$emit("change", $event)
                          }
                        ],
                        blur: function($event) {
                          return _vm.$emit("blur", $event)
                        }
                      }
                    },
                    _vm.limitNumbersInput
                      ? {
                          input: function() {
                            return _vm.limitInput(10)
                          }
                        }
                      : {}
                  )
                )
              : _c(
                  "input",
                  _vm._g(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model,
                          expression: "model"
                        }
                      ],
                      staticClass: "form__textfield",
                      attrs: {
                        name: _vm.name,
                        disabled: _vm.disabled,
                        placeholder: _vm.placeholder,
                        min: _vm.min,
                        max: _vm.max,
                        autocomplete: _vm.autocomplete,
                        type: _vm.type || "text"
                      },
                      domProps: { value: _vm.model },
                      on: {
                        change: function($event) {
                          return _vm.$emit("change", $event)
                        },
                        blur: function($event) {
                          return _vm.$emit("blur", $event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.model = $event.target.value
                        }
                      }
                    },
                    _vm.limitNumbersInput
                      ? {
                          input: function() {
                            return _vm.limitInput(10)
                          }
                        }
                      : {}
                  )
                ),
            _vm._v(" "),
            _vm.type == "password"
              ? [
                  _c("i", {
                    staticClass: "fa fa-eye-slash",
                    staticStyle: {
                      right: "10px",
                      cursor: "pointer",
                      position: "absolute",
                      top: "18px"
                    },
                    attrs: {
                      title:
                        _vm.locales &&
                        _vm.locales.common &&
                        _vm.locales.common.show_password
                    },
                    on: { click: _vm.togglePassword }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            [
              _vm.IsExtraInfo
                ? _c(
                    "div",
                    { staticClass: "form__extra-info__content" },
                    [_vm._t("extra-info")],
                    2
                  )
                : _vm._e()
            ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.errors.has(_vm.newName)
        ? _c("div", { staticClass: "form__field-error" }, [
            _vm._v("\n    " + _vm._s(_vm.errors.first(_vm.newName)) + "\n  ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2abbbd8b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2abbbd8b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VTextfieldPublic.vue
// module id = 418
// module chunks = 1